<template>
  <div class="base-report">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.method" size="mini" >
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="mode" v-show="isShowMode" v-model="searchForm.mode" size="mini" >
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          height="100%"
          @sort-change="sortTable"
          :row-class-name="getRowClass">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMethod === methodType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="header.prop === 'date' && currentMethod === methodType.weekdaily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    <span class="w" :class="weekdayClassByWeekdayName(scope.row.weekdayName)">{{ scope.row.weekdayName }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

export default {
  name: 'ReportSalesCategory',
  data () {
    const methodType = {
      daily: 1,
      monthly: 2,
      weekdaily: 3,
      hourly: 4,
      orderHourly: 5,
    }
    const targetType = {
      category: 3,
    }
    const modeType = {
      item: 1,
      department: 2,
      category: 3,
    }

    return {
      ratioStr: null,
      isLoading: false,
      noData: false,
      methodType: {...methodType},
      targetType: {...targetType},
      modeType: {...modeType},
      methods: [{value: methodType.daily, label: '日毎'}, {value: methodType.monthly, label: '月毎'}, {value: methodType.weekdaily, label: '曜日毎'}, {value: methodType.hourly, label: '時間毎'}],
      categoryModes: [{value: modeType.department, label: '部門'}, {value: modeType.category, label: 'グループ'}],
      isShowMode: true,
      tableSetting: [],
      searchForm: {
        method: methodType.daily,
        mode: modeType.item,
        from_date: null,
        to_date: null,
      },
      items: [],
      groupData: {},
      currentMethod: methodType.daily,
      currentTarget: targetType.category,
      currentMode: modeType.item,
      orgData: [],
      totalData: [],
      form: {},
      csv_filename: '売上詳細.csv',
    }
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('report', ['ratioStrFunction']),
    modes () {
      let result = []
      this.isShowMode = true
      this.searchForm.mode = this.searchForm.mode === this.modeType.item ? this.modeType.department : this.searchForm.mode
      result.push(...this.categoryModes)
      return result
    },
    screenData () {
      let result = []
      for (let data of this.orgData) {
        this.calcDateValue(data.data)
        switch (this.currentMode) {
          case this.modeType.department:
            data.data.code = data.data.departmentCode
            data.data.name = data.data.departmentName
            break
          case this.modeType.category:
            data.data.code = data.data.categoryCode
            data.data.name = data.data.categoryName
            break
        }

        if (data.type === 'subtotal') {
          data.data.name = '【合計】'
        }

        result.push(data.data)
      }
      return result
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.tableSetting = []
      this.totalData = []
      this.orgData = []
      this.currentMethod = this.searchForm.method
      this.currentMode = this.searchForm.mode

      this.$request.reports.details(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method, this.currentTarget, this.searchForm.mode).then(res => {
        this.items = res.body
        if (this.items) {
          this.tableSetting.push({label: this.getDateStr(), prop: 'date', align: 'center', fixed: true, width: '130px'})
          this.tableSetting.push({label: 'コード', prop: 'code', align: 'center', sortable: 'custom', width: '100px'})
          this.tableSetting.push({label: this.getGroupLabelStr(), prop: 'name', align: 'left', sortable: 'custom', width: '160px'})
          this.tableSetting.push({label: '売上', prop: 'sales', align: 'right', sortable: 'custom', width: '130px'})
          this.tableSetting.push({label: '売上(税抜)', prop: 'salesExcludeTax', align: 'right', sortable: 'custom', width: '130px'})
          this.tableSetting.push({label: '個数', prop: 'itemCount', align: 'right', sortable: 'custom', width: '100px'})
          this.tableSetting.push({label: '単価', prop: 'unitPrice', align: 'right', sortable: 'custom', width: '100px'})
          this.tableSetting.push({label: '原価', prop: 'itemCostPrice', align: 'right', sortable: 'custom', width: '100px'})

          for (let record of this.items.records) {
            this.orgData.push(record)
          }
        }

        // get groups data
        if (this.items.groups) {
          for (let group of this.items.groups) {
            this.groupData[group.key] = group
          }
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    sortTable ({column, prop, order}) {
      if (!prop) {
        this.orgData = []
        this.orgData.push(...this.items.records)
        return
      }

      let direction = order === 'ascending' ? 1 : -1
      this.orgData.sort((a, b) => {
        let dataA = a.data
        let dataB = b.data
        let momentA = moment(dataA.date)
        let momentB = moment(dataB.date)
        if (momentA.isAfter(momentB)) {
          return 1
        } else if (momentA.isBefore(momentB)) {
          return -1
        } else {
          if (a.type === 'subtotal') {
            return 1
          } else if (b.type === 'subtotal') {
            return -1
          } else {
            let valueA = dataA[prop]
            let valueB = dataB[prop]
            if (!valueA && !valueB) {
              return 0
            } else if (!valueA) {
              valueA = (typeof valueB === 'string') ? '' : 0
            } else if (!valueB) {
              valueB = (typeof valueA === 'string') ? '' : 0
            }
            let sort = (typeof valueA === 'string') ? valueA.localeCompare(valueB) : valueA - valueB
            return direction * sort
          }
        }
      })
    },
    getRowClass ({row, rowIndex}) {
      if (row.isTotal) {
        return 'row-total'
      } else if (row.isSubTotal) {
        return 'row-subtotal'
      }
      return 'row-data'
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMethod) {
        case this.methodType.daily:
          let date = moment(value).format('YYYY/MM/DD')
          let day = moment(value).locale('ja').format('ddd')
          result = date + '(' + day + ')'
          break
        case this.methodType.monthly:
          result = moment(value).format('YYYY年MM月')
          break
        case this.methodType.weekdaily:
          result = value
          break
        case this.methodType.hourly:
          result = value + ':00〜' + value + ':59'
          break
        case this.methodType.orderHourly:
          result = value + ':00〜' + value + ':59'
          break
      }
      return result
    },
    getDateStr () {
      switch (this.currentMethod) {
        case this.methodType.daily:
          return '年月日'
        case this.methodType.monthly:
          return '年月'
        case this.methodType.weekdaily:
          return '曜日'
        case this.methodType.hourly:
          return '時間'
        case this.methodType.orderHourly:
          return '時間'
      }
    },
    calcDateValue (record) {
      switch (this.currentMethod) {
        case this.methodType.daily:
          record.date = record.date
          break
        case this.methodType.monthly:
          record.date = record.date
          break
        case this.methodType.weekdaily:
          record.date = record.weekdayName
          break
        case this.methodType.hourly:
          record.date = record.hour
          break
        case this.methodType.orderHourly:
          record.date = record.hour
          break
      }
    },
    getGroupLabelStr () {
      switch (this.currentMode) {
        case this.modeType.department:
          return '部門'
        case this.modeType.category:
          return 'グループ'
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'date':
          return this.date(value)
        case 'code':
          return value
        case 'name':
          return value
        case 'itemCode':
          return value
        case 'itemName':
          return value
        case 'salesRatio':
          return this.ratioStr(value)
        case 'countRatio':
          return this.ratioStr(value)
        case 'categoryCode':
          return value
        case 'categoryName':
          return value
        default:
          return addFigure(parseInt(value))
      }
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
    weekdayClassByWeekdayName (name) {
      if (name === '日') {
        return 'sun'
      } else if (name === '土') {
        return 'sat'
      } else if (name === '祝') {
        return 'hol'
      }
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesCategory.vue